// src/hooks/useAssinatura.js — situação da assinatura da empresa (out/26).
//
// Lida UMA vez por carga do app (GET /billing/subscription-status) e
// repartida entre a TopBar (selo "Período de teste"), o menu (cadeado em
// Agenda, Automação e Formulários) e as telas fechadas no teste
// (components/assinatura/BloqueioTeste). Antes cada um pedia a sua e a
// TopBar pedia de novo a cada troca de página.
//
// `atualizarAssinatura()` relê do servidor e avisa todo mundo — é o que a
// janela de ativação chama depois de cobrar, pra o cadeado e o selo sumirem
// sem recarregar a página.
import { useEffect, useState } from 'react';
import api from '../services/Api';

let dados = null;     // a última resposta (ou {} se não deu pra ler)
let pedido = null;    // a leitura em andamento, compartilhada
const ouvintes = new Set();

function avisar() {
  ouvintes.forEach((fn) => fn(dados));
}

function ler() {
  if (pedido) return pedido;
  if (!localStorage.getItem('token')) {
    dados = {};
    return Promise.resolve(dados);
  }
  pedido = api.get('/billing/subscription-status')
    .then((r) => { dados = r.data || {}; })
    // ADMIN não tem empresa (404) e sessão vencida é 401: nada de selo nem
    // de bloqueio — quem cuida disso é o login e o painel.
    .catch(() => { dados = {}; })
    .finally(() => { pedido = null; avisar(); });
  return pedido;
}

export function atualizarAssinatura() {
  return ler();
}

export default function useAssinatura() {
  const [atual, setAtual] = useState(dados);
  useEffect(() => {
    ouvintes.add(setAtual);
    if (dados === null) ler();
    else setAtual(dados);
    return () => { ouvintes.delete(setAtual); };
  }, []);
  return {
    assinatura: atual,
    carregada: atual !== null,
    emTeste: atual?.subscription_status === 'TRIALING',
  };
}
